import { PageHeader, Hero } from '../components/PageComponents';
import './Contact.css';

function Contact() {
  return (
    <>
      <Hero 
        imageSrc="/Images/image_contactus2.jpg"
        imageAlt="Contact Us"
        title="Contact Us"
        subtitle="Get in touch with our team"
        imagePosition="center 35%"
      />

      <div className="container">
        <section className="section">
          <div className="panel">
            <h3>Interested? Need more information?</h3>
            <p>If you're considering using our existing solutions or are interested to build a custom solution, please complete the enclosed form and we will get back to you right away.</p>
          </div>

          <div className="iframe-container">
            <iframe
              title="SMART-WARES Contact Form"
              allowTransparency
              frameBorder="0"
              width="100%"
              height="900px"
              src="https://feedback.smartwareshelpdesk.com/SW/apps/Feedback.aspx?Subject=swsite"
            />
          </div>
        </section>
      </div>
    </>
  );
}

export default Contact;
